import { AgingDetailTotalViewModel } from 'api/backofficeApiClient';

const isColumnHeightToFullTableHeight = <T>(index: number, details: Array<T>) =>
  !index ? details.length : 0;

const getRowSpanValue = (
  index: number,
  details: Array<AgingDetailTotalViewModel>,
) => {
  const previousItem = details[index - 1]?.customerKey;

  const isFirstOccurrence = details[index].customerKey !== previousItem;

  const rowSpan = details.filter(
    (u) => u.customerKey === details[index].customerKey,
  ).length;

  return isFirstOccurrence ? rowSpan : 0;
};

const isShowFooterTableOnLastPage = (
  totalCount: number = 0,
  pageDefaultSizeTable: number,
  pageNumber: number = 0,
) => {
  return totalCount <= pageDefaultSizeTable * (pageNumber + 1);
};

export {
  isColumnHeightToFullTableHeight,
  isShowFooterTableOnLastPage,
  getRowSpanValue,
};
